import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { GoogleMapsModule } from '@angular/google-maps';

import { provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';

import { PagesRoutingModule } from './pages-routing.module';
import { SharedModule } from '../../shared/shared.module';

import { AboutOnePageComponent } from './about-one/about-one.component';
import { LoginPageComponent } from './login/login.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ContactOnePageComponent } from './contact-one/contact-one.component';
import { PartnerComponent } from './partner/partner.component';
import { CarouselModule } from 'ngx-owl-carousel-o';

@NgModule( { declarations: [
        AboutOnePageComponent,
        LoginPageComponent,
        PageNotFoundComponent,
        ContactOnePageComponent,
        PartnerComponent
    ], imports: [CommonModule,
        PagesRoutingModule,
        SharedModule,
        NgbModule,
        RouterModule,
        CarouselModule,
        GoogleMapsModule], providers: [provideHttpClient(withInterceptorsFromDi(), withJsonpSupport())] } )

export class PagesModule { }
